import React from 'react'
import styled from 'styled-components/macro'
import PropTypes from 'prop-types'
import { usePaginatedQuery } from 'react-query'

import { Button, Spacer } from 'components/atoms'
import { InputIcon, Pagination } from 'components/molecules'
import { FileTableSelect } from 'components/organisms'
import { getFiles, FILES_KEY } from 'services/requests'
import { useDebounce } from 'react-use'

const FileSelect = ({
  subweb, lang, onClickUpload, onSelect, icon, filemodule, onClickAdd, rteofile, teste
}) => {
  
  const [search, setSearch] = React.useState('')
  const [debouncedSearch, setDebouncedSearch] = React.useState('');
  const [page, setPage] = React.useState(1)

  useDebounce(
    () => {
      if (debouncedSearch !== search) setDebouncedSearch(search);
    },
    350,
    [search]
  );

  const {
    isLoading,
    isFetching,
    resolvedData,
    refetch
  } = usePaginatedQuery([FILES_KEY, {
    lang,
    subweb,
    currentPage: page,
    search: debouncedSearch,
    recordsPerPage: !filemodule || !rteofile ? 8 : 20
  }], getFiles)

  const totalRecords = React.useMemo(
    () => (
      resolvedData && resolvedData.data
        && resolvedData.data.pagination && resolvedData.data.pagination.totalRecords
        ? resolvedData.data.pagination.totalRecords / 2
        : 0
    ),
    [resolvedData])

  
  const handleClickUpload = (e) => {
    e.stopPropagation();
    onClickUpload()
  }

  const handleSearch = (e) => {
    const searchValue = e.target.value
    setSearch(searchValue)
    setPage(1)
  }

  // react-table pages start at 0 while rc-pagination starts at 1
  const tablePage = React.useMemo(() => page - 1, [page])

  return (
    <>
      <Top>
        <Top.Start>
          <InputIcon
            isLoading={isLoading || isFetching}
            icon="search"
            placeholder="pesquisar ficheiros"
            value={search}
            onChange={handleSearch}
            modifiers={['stretch']}
          />
        </Top.Start>
        {(filemodule && rteofile) && (
          <Top.End>
            <Button modifiers={['dark', 'smallText']} onClick={handleClickUpload}>novo ficheiro</Button>
          </Top.End>
        )}
      </Top>
      <List>
        <Spacer bottom="m">
          <Pagination
            onChange={(nextPage) => setPage(nextPage)}
            current={page}
            total={totalRecords}
          />
        </Spacer>
        <FileTableSelect
          teste={teste}
          files={resolvedData}
          page={tablePage}
          onSelect={onSelect}
          onClickAdd={onClickAdd}
          loading={isLoading}
          icon={icon}
          subweb={subweb}
          lang={lang}
          filemodule = {filemodule}
          rteofile = {rteofile}
          refetchData={ rteofile ? () => refetch() : null}
        />
        <Spacer top="m">
          <Pagination
            onChange={(nextPage) => setPage(nextPage)}
            current={page}
            total={totalRecords}
          />
        </Spacer>
      </List>
    </>
  )
}

const Top = styled.div`
  width: 100%;
  padding-bottom: ${props => props.theme.spacing.l};
  display: grid;
  grid-template-columns: 1fr auto;
  grid-column-gap: ${props => props.theme.spacing.xs};
`;

Top.Start = styled.div``;
Top.End = styled.div`
  button {
    height: 100%;
  }
`;

const List = styled.div``

FileSelect.propTypes = {
  subweb: PropTypes.string,
  lang: PropTypes.string,
  onClickUpload: PropTypes.func,
  onSelect: PropTypes.func,
  icon: PropTypes.string,
  filemodule: PropTypes.bool,
  onClickAdd: PropTypes.func,
  rteofile: PropTypes.bool,
  teste: PropTypes.func
}

FileSelect.defaultProps = {
  subweb: 'ua',
  lang: 'pt',
  onClickUpload: () => {},
  onSelect: () => {},
  icon: 'fal fa-plus',
  filemodule: true,
  onClickAdd: () => {},
  rteofile: true,
  teste: () => {}
}

export default FileSelect
